const shared = {
  radiusSm: 8,
  radiusMd: 12,
  radiusLg: 16,
  shadowSm: "0 1px 2px rgba(15, 23, 42, 0.05)",
  shadowMd: "0 10px 30px rgba(15, 23, 42, 0.08)",
};

export const LIGHT = {
  ...shared,
  pageBg: "#f6f7fb",
  sidebarBg: "#111827",
  headerBg: "rgba(255,255,255,0.94)",
  cardBg: "#ffffff",
  cardBorder: "#e5e7eb",
  divider: "#e5e7eb",
  navActive: "rgba(255,255,255,0.12)",
  navActiveTxt: "#ffffff",
  navTxt: "#cbd5e1",
  navBorder: "#818cf8",
  gridLine: "#e8eaf0",
  tickTxt: "#64748b",
  textPrimary: "#111827",
  textSub: "#475569",
  textMuted: "#64748b",
  textFaint: "#94a3b8",
  textGhost: "#cbd5e1",
  inputBg: "#ffffff",
  inputBorder: "#cbd5e1",
  btnPrimary: "#4f46e5",
  btnPrimaryTxt: "#ffffff",
  btnDanger: "#fee2e2",
  btnDangerTxt: "#b91c1c",
  rowHover: "#f8fafc",
  tagBg: "#eef2ff",
  tagTxt: "#4338ca",
  tooltipBg: "#ffffff",
  tooltipBorder: "#dbe1ea",
  selRow: "#eef2ff",
  accentPrimary: "#4f46e5",
  accentGreen: "#059669",
  accentPink: "#db2777",
  accentOrange: "#ea580c",
  accentYellow: "#ca8a04",
  statusOk: "#059669",
  statusOff: "#94a3b8",
  footerTxt: "#94a3b8",
  secTitleTxt: "#1e293b",
  secTitleBorder: "#4f46e5",
  emptyTxt: "#64748b",
  toggleIcon: "☾",
  toggleLabel: "다크 모드",
  badgeBg: "#eef2ff",
};

export const DARK = {
  ...shared,
  pageBg: "#0b1120",
  sidebarBg: "#070d19",
  headerBg: "rgba(15,23,42,0.94)",
  cardBg: "#111827",
  cardBorder: "#263247",
  divider: "#263247",
  navActive: "rgba(129,140,248,0.16)",
  navActiveTxt: "#ffffff",
  navTxt: "#94a3b8",
  navBorder: "#818cf8",
  gridLine: "#263247",
  tickTxt: "#94a3b8",
  textPrimary: "#f8fafc",
  textSub: "#cbd5e1",
  textMuted: "#94a3b8",
  textFaint: "#64748b",
  textGhost: "#475569",
  inputBg: "#0f172a",
  inputBorder: "#334155",
  btnPrimary: "#6366f1",
  btnPrimaryTxt: "#ffffff",
  btnDanger: "#7f1d1d",
  btnDangerTxt: "#fecaca",
  rowHover: "#172033",
  tagBg: "#242b4d",
  tagTxt: "#c7d2fe",
  tooltipBg: "#020617",
  tooltipBorder: "#334155",
  selRow: "#252f54",
  accentPrimary: "#818cf8",
  accentGreen: "#34d399",
  accentPink: "#f472b6",
  accentOrange: "#fb923c",
  accentYellow: "#facc15",
  statusOk: "#34d399",
  statusOff: "#64748b",
  footerTxt: "#64748b",
  secTitleTxt: "#e2e8f0",
  secTitleBorder: "#818cf8",
  emptyTxt: "#94a3b8",
  toggleIcon: "☀",
  toggleLabel: "라이트 모드",
  badgeBg: "#242b4d",
};

export const CHART_COLORS = [
  "#4f46e5", "#059669", "#db2777", "#ea580c", "#0284c7",
  "#7c3aed", "#ca8a04", "#0d9488", "#dc2626", "#65a30d",
];

const regionNames = typeof Intl !== "undefined" && Intl.DisplayNames
  ? new Intl.DisplayNames(["ko"], { type: "region" })
  : null;

export const COUNTRY_NAMES = new Proxy({ none: "기타" }, {
  get(target, property) {
    if (typeof property !== "string") return target[property];
    if (property in target) return target[property];
    const code = property.toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return property;
    try { return regionNames?.of(code) || property; } catch { return property; }
  },
});

export function toCssVariables(theme) {
  return {
    "--page-bg": theme.pageBg,
    "--sidebar-bg": theme.sidebarBg,
    "--header-bg": theme.headerBg,
    "--card-bg": theme.cardBg,
    "--card-border": theme.cardBorder,
    "--divider": theme.divider,
    "--text-primary": theme.textPrimary,
    "--text-sub": theme.textSub,
    "--text-muted": theme.textMuted,
    "--text-faint": theme.textFaint,
    "--input-bg": theme.inputBg,
    "--input-border": theme.inputBorder,
    "--primary": theme.accentPrimary,
    "--row-hover": theme.rowHover,
    "--shadow-sm": theme.shadowSm,
    "--shadow-md": theme.shadowMd,
  };
}
